import { post } from 'helpers/api';

export const END_EMAIL_GROUP = 'PEOPLE-END_EMAIL_GROUP';
export function endEmailGroup() {
  return { type: END_EMAIL_GROUP };
}

export const START_EMAIL_GROUP = 'PEOPLE-START_EMAIL_GROUP';
export function startEmailGroup(requirementSetsParents) {
  return (dispatch, getState) => {
    post(getState().paths.contactsEmailsPath, { contacts: requirementSetsParents }).then(({ emails }) => {
      dispatch({
        emails,
        type: START_EMAIL_GROUP
      });
    });
  };
}


